// src/components/Footer.js — Branded footer copy
import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { APP_TITLE } from '../config/branding';

const Footer = () => {
  const theme = useTheme();
  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 2,
        textAlign: 'center',
        color: '#fff',
        backgroundColor: theme.palette?.secondary?.main || '#e1ac2a',
        borderTop: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        © {new Date().getFullYear()} · {APP_TITLE} · Developed by Lemda (Pvt) Ltd
      </Typography>
    </Box>
  );
};

export default Footer;
